type Paths = {
  [key: string]: string;
};

export const paths: Paths = {
  root: '/',
  consultations_list: '/consultations',
  about: '/about-us',
  profile: '/profile',
  consultations: '/consultations/:slug',
  consultationTemplates: '/consultation-templates/:slug',
  propositions: '/propositions/:id',
  consultation: '/consultation/:id',
  joinUs: '/join-us',
  notFound: '/not-found',
  login: '/login',
  logout: '/logout',
  project: '/projects/:slug',
  projectNewsItem: '/projects/:slug/news/:moduleId,:newsItemId',
  projectTemplate: '/project-template/:slug',
  page: '/:slug',
};
